import(/* webpackMode: "eager" */ "/app/src/app/(landing-page)/(static-pages)/data-usage/page.tsx")